/*
 * 设备登记接口
 */

import { post, get } from 'api/http'

export default {

    // 删除建筑
    deleteBuilding(data) {
        return get('/device/del_building_info', data)
    }

    // // 获取设备登记信息
    // getDeviceRegister(data) {
    //     return get('/device/query_device_register_info', data)
    // },

    // // 添加设备登记
    // addDeviceRegister(data) {
    //     return post('/device/add_device_register_info', data)
    // },

    // // 获取设备登记详情
    // getDeviceDetail(data) {
    //     return get('/device/device_register_detail', data)
    // },

    // // 修改设备登记
    // updateDeviceRegister(data) {
    //     return post('/device/update_device_register_info', data)
    // },

    // // 修改设备状态
    // updateDeviceState(data) {
    //     return get('/device/update_device_state', data)
    // },

    // // 删除设备登记
    // deleteDeviceRegister(data) {
    //     return get('/device/del_device_register_info', data)
    // },

    // // 获取默认选项，初始化
    // getDeviceDefault(data) {
    //     return get('/device/get_default', data)
    // },

    // // 获取设备名称
    // getDeviceName(data) {
    //     return get('/device/get_sys_device_info', data)
    // },

    // // 添加建筑
    // addBuilding(data) {
    //     return get('/device/add_building_info', data)
    // },

    // // 获取建筑
    // getBuilding(data) {
    //     return get('/device/query_building_info', data)
    // },

    // // 更新建筑
    // updateBuilding(data) {
    //     return post('/device/update_building_info', data)
    // },
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/register.js